import React from 'react'
import { prepareData } from 'utils/googleData'

// Helper function to extract YouTube video ID from various formats
const extractYouTubeVideoId = (url: string): string => {
    if (!url) return ''

    // Handle direct video ID format (e.g., "LKNlIuMC5Iw")
    if (!url.includes('youtube.com') && !url.includes('youtu.be')) {
        return url
    }

    // Handle youtu.be format
    if (url.includes('youtu.be/')) {
        return url.split('youtu.be/')[1]?.split('?')[0] || ''
    }

    // Handle youtube.com format
    if (url.includes('youtube.com')) {
        const urlParams = new URLSearchParams(url.split('?')[1] || '')
        return urlParams.get('v') || ''
    }

    return ''
}

// Video component that renders YouTube embed
const VideoEmbed = ({ videoId }: { videoId: string }) => {
    if (!videoId) return null

    return (
        <div className="relative h-0 w-full overflow-hidden rounded-lg pb-[56.25%] shadow-lg">
            <iframe
                className="absolute top-0 left-0 h-full w-full"
                src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
                title="Team Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
    )
}

export const AboutHero2 = (props: any) => {
    const {
        enable,
        title,
        subtitle,
        description,
        cta,
        direction,
        style,
        videoId, // New prop for video ID
    } = prepareData({ props })

    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    console.log(`AboutHero2 ${videoId}`)

    // Extract video ID from the prop
    const extractedVideoId = extractYouTubeVideoId(videoId || '')

    return (
        <>
            <header id="our-story" className="px-4 pb-4 md:px-12 md:pb-8">
                <h1
                    className="mb-4 text-center text-4xl leading-none md:text-6xl"
                    dangerouslySetInnerHTML={{ __html: title }}
                ></h1>
                <h3 className="text-center font-semibold opacity-60">
                    <p className="mb-0 pb-0 text-xl">{subtitle}</p>
                </h3>
            </header>

            <div className="mx-auto max-w-screen-xl px-4 pb-12 md:px-8">
                <div className="flex flex-col items-center justify-center">
                    {extractedVideoId ? (
                        <div className="w-full max-w-4xl">
                            <VideoEmbed videoId={extractedVideoId} />
                        </div>
                    ) : (
                        <div className="bg-gray-200 flex h-96 w-full max-w-4xl items-center justify-center rounded-lg">
                            <p className="text-gray-500 text-lg">Video not available</p>
                        </div>
                    )}

                    {description && (
                        <div className="mt-8 max-w-3xl text-center">
                            <p className="text-lg leading-relaxed opacity-80">{description}</p>
                        </div>
                    )}

                    {cta && (
                        <div className="mt-8 text-center">
                            <a
                                href={cta.url || '#'}
                                className="bg-blue-600 hover:bg-blue-700 inline-block rounded-lg px-8 py-3 font-semibold text-white transition-colors duration-200"
                            >
                                {cta.text || 'Learn More'}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
